export function DistortionCorrectionEnabled(photo) {
  if (photo?.vignetting_correction_2) {
    if (photo.vignetting_correction_2.split(',')[7] === '1') return true;
    if (photo.vignetting_correction_2.split(',')[7] === '0') return false;
  }
  return null;
}
